import { Component, Input, DoCheck, OnChanges, ApplicationRef, ViewChild, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, AbstractControl, AbstractControlDirective } from '@angular/forms';

import { CpqInputBase } from '../cpq-input-base';
import { TranslationService } from '../common/services/translation.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'cpq-textarea',
    templateUrl: './cpq-textarea.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CpqTextareaComponent,
            multi: true
        }
    ],
    styleUrls: ['./cpq-textarea.component.scss'],
    standalone: false
})

export class CpqTextareaComponent extends CpqInputBase implements OnChanges {
    @Input('control') control?: AbstractControlDirective | AbstractControl;
    @Input('rows')rows: number = 6;
    @ViewChild('textarea', { static: false }) textarea: ElementRef;
    @ViewChild('formulaBuilder', { static: false }) formulaBuilder: ElementRef;
    public placeholderMsg = '';

    constructor(
        public translationService: TranslationService,
        public ref: ApplicationRef,
        public dialog: MatDialog) {
        super(ref, dialog);
    }

    ngOnChanges() {
        if (this.placeholder) {
            this.placeholderMsg = this.translationService.translate(this.placeholder);
        }
    }

    public onResize(sizeData) {
        if (this.textarea.nativeElement.closest('div[class^="col"]')) {
            this.textarea.nativeElement.closest('div[class^="col"]').style.width = sizeData.width + 'px';
        }

        if (this.formulaBuilder) {
            this.formulaBuilder.nativeElement.style.width = sizeData.width + 'px';
        }
    }
}